import { useGetAllCities } from '@/hooks/data/masterDataHook';

import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {
  regionId?: string | null | undefined;
}
export default function CityInput({ regionId, ...props }: Props) {
  const { data, isLoading } = useGetAllCities();

  const cities = React.useMemo(() => {
    if (regionId) {
      return data?.data?.filter(x => x.regionId === regionId) || [];
    }
    return data?.data || [];
  }, [data, regionId]);
  return (
    <Select
      maxTagCount="responsive"
      allowClear
      loading={isLoading}
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {cities.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {c.cityName}
          </Select.Option>
        );
      })}
    </Select>
  );
}
